export const SIDE_MAP = {
  left: 'left',
  right: 'right',
};